module.exports = __webpack_public_path__ + "img/content-management-system-listing.768a462e.jpg";